import { ShareLinksAPIType } from "shared/types/ShareLink"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function projectShareLinkSerializer(_: any, headers: Headers) {
  headers.set("Content-Type", "application/json")
  return {
    body: JSON.stringify({
      data: { type: ShareLinksAPIType },
      jsonapi: { version: "1.0" }
    }),
    headers
  }
}
